import { steps } from "@/mocks/homeData";

export default function HowToFind() {
  return (
    <section id="how" className="w-full scroll-mt-20 bg-secondary-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-accent-700">HOW TO / 查找方法</span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            如何快速找到可用资源
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            与其在成百上千的搜索结果里反复试错，不如按下面这套顺序走一遍。它不保证每次都能一次命中，
            但能把无效搜索和跳转降到最低。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {steps.map((step) => (
            <li
              key={step.step}
              className="group relative flex flex-col rounded-xl border border-background-200 bg-background-50 p-6 transition-colors hover:border-primary-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                  <i className={`${step.icon} text-xl`}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">{step.step}</span>
              </div>
              <h3 className="mt-5 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex flex-col items-start gap-3 rounded-xl border border-accent-200 bg-accent-50 p-5 sm:flex-row sm:items-center">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
            <i className="ri-lightbulb-flash-line text-lg"></i>
          </span>
          <p className="text-sm leading-relaxed text-accent-900">
            小技巧：如果某个渠道反复打不开，先记录它已经尝试过，然后跳到下一类渠道。
            把“试错清单”写下来，比在同一个页面里来回点击要高效得多。
          </p>
        </div>
      </div>
    </section>
  );
}